export default __webpack_public_path__ + "static/media/telefonicaweb-bold-webfont.1785776060741.ttf";